import {makeAutoObservable} from "mobx";
import {from} from "rxjs";
import type {MithraMaterializedApi} from "~/services/MithraMaterializedApi";
import {AxoisRequestManager} from "~/stores/managers/RequestManager";
import type {PartHistoryEntry} from "~/services/classes/PartHistory";

export class PartHistoryDialogStore {
    partId: number | undefined = undefined;

    readonly historyRM = new AxoisRequestManager<{partId: number}, PartHistoryEntry[]>(
        ({partId}) => from(this.api.getPartHistory(partId)));

    constructor(private api: MithraMaterializedApi) {
        makeAutoObservable(this);
    }

    get isOpen(): boolean {
        return this.partId !== undefined;
    }

    open(partId: number) {
        this.partId = partId;
        this.historyRM.request({partId});
    }

    close() {
        this.partId = undefined;
        this.historyRM.cleanup();
    }
}
